import { ElementType, HTMLAttributes } from 'react';

interface CardProps extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
}

export function Card({ as: Tag = 'div', className = '', children, ...rest }: CardProps) {
  return (
    <Tag
      {...rest}
      className={`bg-hs-surface border border-hs-border rounded-hs-xl ${className}`}
    >
      {children}
    </Tag>
  );
}
